module.exports = __webpack_public_path__ + "img/trusted.25e62bc.webp";